module.exports = __webpack_public_path__ + "static/media/gatot-1.64b05454.jpg";